// extracted by mini-css-extract-plugin
module.exports = {"container":"_gBF38SEH","content":"_1TaqGUIJ"};